import { Box, Spacer } from '@dtx-company/shared-components/src'
import { LargeProductSuitCardData, LargeProductSuitCardsData } from '../types'
import { asText } from '@prismicio/client'
import LargeProductSuitCard from './LargeProductSuitCard'
import LargeProductSuitCardMobile from './LargeProductSuitCardMobile'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import React from 'react'

//sectionId is used for navigation
const LargeProductSuitCardsSection: React.FC<{
  data?: LargeProductSuitCardsData
  sectionId: string
}> = ({ data, sectionId }) => {
  if (!data) return null

  const header = (
    <PrismicText
      key={asText(data.primary?.subheader)}
      richTextField={data.primary?.subheader}
      variant="display/large"
      fontSize={{ _: '24px', md: '28px', lg: '32px' }}
      lineHeight={{ _: '30px', lg: '40px' }}
      textAlign="center"
      marginBottom="56px"
      px={{ _: '22px', md: '133px' }}
    />
  )

  const buildCards = (Component: React.FC<{ data?: LargeProductSuitCardData }>): JSX.Element[] =>
    data.items?.map((item, idx) => {
      const isNotLastCard = idx < (data.items?.length ?? 0) - 1
      return (
        <React.Fragment key={asText(item.subheader)}>
          <Component data={item} />
          {isNotLastCard && <Spacer mb="56px" />}
        </React.Fragment>
      )
    }) ?? []

  const cards = buildCards(LargeProductSuitCard)
  const mobileCards = buildCards(LargeProductSuitCardMobile)

  // insert header after 1st card
  cards?.splice(1, 0, header)
  mobileCards?.splice(1, 0, header)

  return (
    <Box display="block" id={sectionId}>
      <Spacer mt={{ _: '32px', md: '56px', lg: '96px' }} />
      <Box display={{ _: 'block', lg: 'none' }}>{mobileCards}</Box>
      <Box display={{ _: 'none', lg: 'block' }}>{cards}</Box>
      <Spacer mb={{ _: '32px', md: '56px', lg: '96px' }} />
    </Box>
  )
}

export default LargeProductSuitCardsSection
